// Generate completion sounds with the Web Audio API (no external assets needed)
let _ctx = null;
function ctx() {
  if (!_ctx) {
    const C = window.AudioContext || window.webkitAudioContext;
    _ctx = new C();
  }
  if (_ctx.state === "suspended") _ctx.resume();
  return _ctx;
}

function playTone({ freq, duration, type = "sine", gain = 0.18, startOffset = 0 }) {
  const a = ctx();
  const o = a.createOscillator();
  const g = a.createGain();
  o.type = type;
  o.frequency.value = freq;
  const now = a.currentTime + startOffset;
  g.gain.setValueAtTime(0.0001, now);
  g.gain.exponentialRampToValueAtTime(gain, now + 0.01);
  g.gain.exponentialRampToValueAtTime(0.0001, now + duration);
  o.connect(g).connect(a.destination);
  o.start(now);
  o.stop(now + duration + 0.05);
}

export function playSound(name) {
  try {
    if (name === "bell") {
      // Bell: two stacked sine tones with a quick decay
      playTone({ freq: 880, duration: 1.2, type: "sine", gain: 0.22 });
      playTone({ freq: 1318.5, duration: 1.0, type: "sine", gain: 0.12, startOffset: 0.01 });
      playTone({ freq: 660, duration: 1.4, type: "sine", gain: 0.08, startOffset: 0.02 });
    } else if (name === "chime") {
      // Chime: arpeggio
      const notes = [523.25, 659.25, 783.99, 1046.5];
      notes.forEach((f, i) => playTone({ freq: f, duration: 0.6, type: "triangle", gain: 0.18, startOffset: i * 0.12 }));
    } else {
      // Digital beep: 3 short square pulses
      for (let i = 0; i < 3; i++) {
        playTone({ freq: 1200, duration: 0.12, type: "square", gain: 0.16, startOffset: i * 0.18 });
      }
    }
  } catch (e) {
    // ignore
  }
}

export const SOUND_OPTIONS = [
  { value: "bell", label: "Bell" },
  { value: "chime", label: "Chime" },
  { value: "beep", label: "Digital Beep" },
];
